/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "446")


  
    
export interface API50828Item {
  
  /**  */
  id?: number;
  
  /** 任务标题 */
  taskTitle?: string;
  
  /** <pre>,任务状态(1:未开始;2:进行中;3:已关闭;5:已完成),,详见枚举定义：com.ywwl.foundation.teamwork.client.enums.TaskStatusEnum,<pre> */
  taskStatus?: number;
  
  /** 任务状态(1:未开始;2:进行中;3:已关闭;5:已完成) */
  taskStatusName?: string;
  
  /** 优先级(1:较低,2:普通,3:紧急,4:非常紧急),详见TaskPriorityEnum */
  taskPriority?: number;
  
  /** 优先级(1:较低,2:普通,3:紧急,4:非常紧急),详见TaskPriorityEnum */
  taskPriorityName?: string;
  
  /** 计划开始时间yyyy-MM-ddHH:mm */
  startTime?: any;
  
  /** 计划完成时间yyyy-MM-ddHH:mm */
  endTime?: any;
  
  /** 任务创建人发起人 */
  creator?: string;
  
  /** 任务发起者姓名 */
  creatorName?: string;
  
  /** 用户状态,,@seecom.ywwl.foundation.teamwork.client.enums.UserStatusEnum */
  creatorStatus?: string;
  
  /** 任务发起者头像 */
  creatorLogo?: string;
  
};
    
  



export interface API50828Req {
  
  /** (Long) */
  parentTaskId?: string;
    
};



export interface API50828Res {
  /** T  */
  list?: API50828Item[];
  /**   */
  totalNumber?: any;
  /**   */
  totalPage?: any;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: any;
  /**   */
  pageIndex?: any;
  
};


// 50828 查询子任务列表

export interface IUseGetAPI50828Return {
  /** 查询子任务列表: 接口请求状态 */
  isAPI50828Loading: boolean;
  /** 查询子任务列表: 接口请求返回数据 */
  dataAPI50828: API50828Res;
  /**  查询子任务列表: 接口数据请求方法 */
  fetchAPI50828Data:  (inputs: API50828Req, config?: YWRequestConfig) => Promise<API50828Res>;
  /** 查询子任务列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI50828 = ():IUseGetAPI50828Return => {
  let isMount = true;
  const [isAPI50828Loading, setIsAPI50828Loading] = useState(false);
  const [dataAPI50828, setDataAPI50828] = useState<API50828Res>({} as API50828Res);
  const requestUrl = `${basePath}/team-work/workTask/listSubTask`;

  const fetchAPI50828Data = async (inputs: API50828Req, config?: YWRequestConfig): Promise<API50828Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API50828Req>) || {}) as API50828Req;
    
  
    if ( isMount ) {
      setIsAPI50828Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API50828Res>(`${basePath}/team-work/workTask/listSubTask?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI50828(res || {} as API50828Res);
        setIsAPI50828Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI50828Loading(false);
      }
      return false as unknown as API50828Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI50828Loading,
    dataAPI50828,
    fetchAPI50828Data,
    requestUrl,
  }
}

